import CloseButton from 'Components/Common/CloseButton';
import RadioGroup from 'Components/input/RadioGroup/RadioGroup';
import React, { useEffect, useState } from 'react';
import { Offcanvas, OffcanvasBody } from 'reactstrap';
import { defaultInvitesFilters } from 'slices/campaigns/invites/reducer';
import { CampaignInvitesFilters } from 'types/campaign/invites';

interface InviteFiltersProps {
    isOpen: boolean;
    onClose: () => void;
    defaultFilters: CampaignInvitesFilters;
    onApply: (filters: CampaignInvitesFilters) => void;
}

const YES_NO_OPTIONS = [
    { id: 'all', label: 'All' },
    { id: 'y', label: 'Yes' },
    { id: 'n', label: 'No' },
];

const MODE_OPTIONS = [
    { id: 'all', label: 'All' },
    { id: 'manual', label: 'Manual' },
    { id: 'search', label: 'Search' },
    { id: 'discovery', label: 'Discovery' },
];

const toFilterTileValue = (value?: string) => (value ? value : 'all');

const InviteFilters: React.FC<InviteFiltersProps> = ({ isOpen, onClose, defaultFilters, onApply }) => {
    const [filters, setFilters] = useState<CampaignInvitesFilters>(defaultFilters);

    useEffect(() => {
        setFilters(defaultFilters);
    }, [defaultFilters, isOpen]);

    const applyFilters = (next: CampaignInvitesFilters) => {
        onApply({
            ...next,
            page: 1,
            applied: next.applied === 'all' || !next.applied ? '' : next.applied,
            collaborated: next.collaborated === 'all' || !next.collaborated ? '' : next.collaborated,
            mode: next.mode === 'all' || !next.mode ? '' : next.mode,
        });
        onClose();
    };

    return (
        <Offcanvas isOpen={isOpen} toggle={onClose} direction="end">
            <CloseButton onClose={onClose} />
            <OffcanvasBody className="p-0 position-relative">
                <div className="payments-offcanvas-bg" />
                <div className="filters p-4">
                    <div className="form-group filter-item">
                        <label htmlFor="invite-applied" className="filter-label">Applied?</label>
                        <RadioGroup
                            name="invite-applied"
                            options={YES_NO_OPTIONS}
                            defaultValue={toFilterTileValue(filters.applied)}
                            onChange={(applied) => setFilters({ ...filters, applied: applied as CampaignInvitesFilters['applied'] })}
                            selectFirstWhenNoValueProvided={false}
                        />
                    </div>
                    <div className="form-group filter-item">
                        <label htmlFor="invite-collaborated" className="filter-label">Collaborated?</label>
                        <RadioGroup
                            name="invite-collaborated"
                            options={YES_NO_OPTIONS}
                            defaultValue={toFilterTileValue(filters.collaborated)}
                            onChange={(collaborated) =>
                                setFilters({ ...filters, collaborated: collaborated as CampaignInvitesFilters['collaborated'] })
                            }
                            selectFirstWhenNoValueProvided={false}
                        />
                    </div>
                    <div className="form-group filter-item">
                        <label htmlFor="invite-mode" className="filter-label">Mode</label>
                        <RadioGroup
                            name="invite-mode"
                            options={MODE_OPTIONS}
                            defaultValue={toFilterTileValue(filters.mode)}
                            onChange={(mode) => setFilters({ ...filters, mode: mode as CampaignInvitesFilters['mode'] })}
                            selectFirstWhenNoValueProvided={false}
                        />
                    </div>
                </div>
                <div className="filters-offcanvas-footer d-flex justify-content-between align-items-center px-3 p-4 gap-2">
                    <button
                        type="button"
                        className="theme-btn theme-btn-lg w-100 btn-primary-outlined"
                        onClick={() => applyFilters({ ...defaultInvitesFilters })}
                    >
                        Reset
                    </button>
                    <button
                        type="button"
                        className="theme-btn theme-btn-lg w-100 btn-primary"
                        onClick={() => applyFilters(filters)}
                    >
                        Apply
                    </button>
                </div>
            </OffcanvasBody>
        </Offcanvas>
    );
};

export default InviteFilters;
